import { Pipe, PipeTransform } from '@angular/core';
import { ItemValueDataModel } from '../../modules/crud/items/item-value/classes/item-value.model';
import { FieldValueType } from '../../modules/crud/fields/field-value/classes/field-value.model';
import { DataTypeHelperFactory } from '@dash/randy/shared/service/collection-items/data-type-helper-factory';

@Pipe({
    name: 'collectionItemDataDisplay',
    standalone: false
})
export class CollectionItemDataDisplayPipe implements PipeTransform {
  async transform(value: ItemValueDataModel, type: FieldValueType, locale?: string): Promise<string> {
    const dataTypeHelper = DataTypeHelperFactory.getDataTypeHelper(type);
    return dataTypeHelper.getDataAsString(value, locale);
  }
}
